
import * as handlebars_family from "../handlebars_family.js";

const TPL = handlebars_family.addTemplate("mealplanner/page_recipebox_nc",{"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<flexcol class=\"fw-main\" style=\"max-width:1200px;font-size:80%;\"><flexauto class=\"mealplanner\"><flexcol class=\"fw-white-pane\" id=\"recipe-container\"></flexcol></flexauto></flexcol> ";
},"useData":true});
export default TPL;